import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer, { SocialLinkProps } from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";
import {
  FooterContainerUp,
  FooterContainerRight,
} from "../components/Footer/styles";
import { SvgIcon } from "../common/SvgIcon";

const Router = () => {
  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };
  return (
    <Suspense fallback={null}>
      <Styles />
      <section
        className="hide-on-mobile"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row-reverse",
          paddingInline: "15px",
          backgroundColor: "rgb(255, 232, 57)",
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
        }}
      >
        <FooterContainerRight>
          <SocialLink href="mailto:magic.piksi@gmail.com" src="email.svg" />
        </FooterContainerRight>
        <span style={{ fontSize: "28px", fontWeight: "600" }}>
          Piksi Magic – Tvoja zabava, moj trik!
        </span>
        <FooterContainerUp>
          <SocialLink
            href="https://www.instagram.com/piksi.magician"
            src="instagram.svg"
          />
          <SocialLink
            href="https://m.facebook.com/piksimagic.rs/"
            src="facebook.svg"
          />
          <SocialLink
            href="https://www.tiktok.com/@piksimagician"
            src="tiktok.svg"
          />
        </FooterContainerUp>
      </section>

      <Header />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 100"
        preserveAspectRatio="none"
        style={{ transform: "rotate(180deg)", marginBottom: "-8px" }}
      >
        <path
          fill="#f1f2f4"
          opacity="0.33"
          d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
        ></path>
        <path
          fill="#f1f2f4"
          opacity="0.66"
          d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
        ></path>
        <path
          fill="#f1f2f4"
          d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
        ></path>
      </svg>

      <Footer />
    </Suspense>
  );
};

export default Router;
